import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Button,
  Uploader,
  ErrorMsg,
} from "@onegovbugs/onegov-react-components";
import { isCompleted, validate, scrollToError } from "../../../utils/Validation";
import styles from "./UploadDocument.module.scss";
import { saveApplication, storeAttachmentDetail, saveImportExportApplication } from "../../../redux/actions";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import ScrollToTop from "../../../utils/ScrollToTop";
import PciWarning from "../../../components/common/pciWarning/PciWarning";

const UploadDocument = (props) => {
  RedirectIfCaptchaNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();
  const oidc = useSelector((state) => state.oidc);
  const accessToken = oidc.user && oidc.user.access_token;

  const attachmentDetails = useSelector((state) => state.attachmentDetails);

  const application = useSelector((state) => state.application);

  const [poiFilesAttached, setPoiFilesAttached] = useState(
    attachmentDetails && attachmentDetails.poiDocumentList
      ? JSON.parse(attachmentDetails.poiDocumentList)
      : []
  );
 
  
  const poiDocTypesArray = [
    {
      value: "Driver Licence",
      label: "Driver Licence",
    },
    {
      value: "Photo Card",
      label: "Photo Card",
    },
    {
      value: "Passport Photo Page",
      label: "Passport Photo Page",
    },
    {
      value: "ADF Photo ID Card",
      label: "ADF Photo ID Card",
    },
    {
      value: "Utility Bill",
      label: "Utility Bill",
    },
    {
      value: "Phone Bill",
      label: "Phone Bill",
    },
    {
      value: "Bank/Credit Card Statement",
      label: "Bank/Credit Card Statement",
    },
    {
      value: "Rental Agreement",
      label: "Rental Agreement",
    },
    {
      value: "Insurance Policy",
      label: "Insurance Policy",
    },
    {
      value: "Government Letter (e.g. NDIS, Council)",
      label: "Government Letter (e.g. NDIS, Council)",
    }
  ]
  // validators
  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({   
    poiFilesAttachedDescription: false,
    poiFilesAttachmentType: false,
    poiHasAttachment :  false
  });
  useEffect(() => {
    validate(validators, setErrors);
  }, [poiFilesAttached]);

  const validators = [
   {
      fieldName: "poiFilesAttachedDescription",
      fieldValue: poiFilesAttached,
      isValid: (v) => {
        let flag = true;
        v.map((attachment) => {
          if ((!attachment.description || !isCompleted(attachment.description)) && attachment.status === 'done') {
            flag = false;
          }
        });
        return flag;
      },
    },
    {
      fieldName: "poiFilesAttachmentType",
      fieldValue: poiFilesAttached,
      isValid: v => {
        let flag = true;
        v.map(attachment => {
          if (!attachment.attachmentType && attachment.status === 'done') {
            flag = false;
          }
        });
        return flag;
      },
    },
    {
      fieldName: "hasPOIAttachment",
      fieldValue: poiFilesAttached,
      isValid: (v) => {
        let flag = false;
        v.map(attachment => {
          if (attachment.status === 'done') {
            flag = true;
          }
        });
        return flag;
      }
    }
  ];  

  const storeData = (finished) => {
    // delete rejected files    
    poiFilesAttached.map((attachment,i) => {
      if (attachment.status !== 'done') {
        poiFilesAttached.splice(i, 1);
      }
    });

    const updatedPOIAttachments = poiFilesAttached.map((attachment,i) => {
      if (attachment.status == 'done') {
        return {...attachment, isPoiDocument: true};
      }
      return attachment;
    });

    
    const attachment = {
      poiDocumentList: JSON.stringify(updatedPOIAttachments),
      finished: finished,
      step : 8
    };
   
    dispatch(storeAttachmentDetail(attachment));
  };

  return (
    <div className={styles.mainCont}>   
     <div className={"row"}>
        <div className={"col-12"}>
          <PciWarning />
        </div>
      </div>
      <div className={`row `}>
        <div className={`col-12`}> 
            <p><b>Your application requires a valid proof of identity and current address that matches the information in this application.</b></p>
                <p>
                   <b>You need to upload either:</b>
                   <ul className={styles.dashedList}>
                     <li>Driver's licence (front and back)</li>
                     <li>Photo Card (front and back)</li>
                     <li>Passport + Proof of address document</li>
                     <li>ADF Photo ID Card + Proof of address document</li>
                   </ul>
                 </p>
                 <p>
                    Drivers Licence or Photo Card:
                    <ul className={styles.dashedList}>
                     <li>Must be issued by an Australian State or Territory</li>
                     <li>Both front and back need to be uploaded</li>
                   </ul>
                 </p>
                 <p>
                   If you are uploading your Passport or ADF Photo ID Card, you need to provide a proof of address document issued in the last 3 months.
                 </p>         
        </div>
      </div>
      <br/>
      <div className={"row"}>
        <div className={`col-12`}>
          <Uploader
            baseUrl={process.env.REACT_APP_BASE_URL}
            uploadUrl={`/nativespeciesapi/V1/attachments/create`}
            removeUrl={`/nativespeciesapi/V1/attachments/delete`}
            onFilesChange={setPoiFilesAttached}
            acceptExtra={
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
            files={poiFilesAttached}
            uuid={application.applicationId}
            accessToken={accessToken}
            applicationId={application.applicationId}
            name={"poiAttachments"}
            requireDescription
            documentTypes={poiDocTypesArray}
            {...props}
          />
          {errors.poiFilesAttachedDescription && showErrors ? (
            <div className={"row"}>
              <div className={`col-6 ${styles.errorContainer}`}>
                <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Please add description of the Proof of Identity file attached"}
                />
              </div>
            </div>
          ) : null}
          {errors.poiFilesAttachmentType && showErrors ? (
            <div className={"row"}>
              <div className={`col-6 ${styles.errorContainer}`}>
                <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Please select the Proof of Identity attachment type"}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {errors.hasPOIAttachment && showErrors ? (
        <ErrorMsg
          className={"ErrorMsg_error"}
          type={"error"}
          description={"Please add Proof of Identity attachment."}
        />
      ) : null}

      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                storeData(true);
                dispatch(
                  saveImportExportApplication("step4", () => {
                    props.history.push(`./dashboard`);
                  })
                );
                setShowErrors(false);
              } else {
                setShowErrors(true);
                 scrollToError();
              }
            }}
          >
            Continue
          </Button>

          <Button
            secondary
            onClick={() => {
              storeData(false);
              dispatch(
                saveImportExportApplication("step4", () => {
                    props.history.push(`./dashboard`);
                  })
              );
            }}
          >
            Save & exit section
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <UploadDocument {...props} />);
